import React from "react"
import ListGroup from 'react-bootstrap/ListGroup';
import soundIcon from "../images/iconmonstr-audio-21.svg"
import {
  icon,
} from './songs-list.module.css'
// import styles from "./songs-list.module.css";

const SongsList = ({ playlist, activeTrackIndex, onSelectTrackIndex }) => {
  // const {mylist} = styles;
  return (
    <div style={{overflow:"hidden", overflowY:"scroll", aspectRatio:"1/1"}}>
      <ListGroup defaultActiveKey="#link1" >
      <style type="text/css">
      {`
      .list-group-item-song {
        background-color: black;
        color: rgba(255,255,255,0.7);
      }
      .list-group-item-song:hover {
        background-color:rgba(140, 3, 28, 0.4);
        color: rgba(255,255,255,0.7);
      }
      .list-group-item-song:focus {
        background-color:rgba(140, 3, 28, 0.5);
        color: rgba(255,255,255,0.7);
      }
      `}
    </style>
      {
        playlist.map((song, i) => 
          <ListGroup.Item variant="song" action onClick={() => onSelectTrackIndex(i)}>
            <img src={soundIcon} className={icon} width="17px" alt={`Play song ${song.title.split("-").splice(1).join("-")}`}/>
            {song.title.split("-").splice(1).join("-")}
          </ListGroup.Item>
        )
      }
      </ListGroup>
    </div>
  )
  }


export default SongsList

/* <ListGroup.Item action onClick={alertClicked}> */